import { Box, Stack } from '@mui/material'

import DirectDeals from './DirectDeals/DirectDeals'
import PackConversions from './PackConversions'

export default function ActionCenter() {
	return (
		<Box data-testid="action-center">
			<Stack spacing={4} sx={{ width: '100%' }}>
				<DirectDeals />
				<PackConversions />
			</Stack>
		</Box>
	)
}
